module.exports = __webpack_public_path__ + "static/media/farm_pharm_16.ee5fcdbf.jpg";